export default __webpack_public_path__ + "static/media/restup-php.2901da31.png";